import { render } from "./PruefkriteriumDetailEditModal.pug?vue&type=template&id=772d6bb7&lang=pug"
import script from "./PruefkriteriumDetailEditModal.js?vue&type=script&lang=js"
export * from "./PruefkriteriumDetailEditModal.js?vue&type=script&lang=js"

import "./PruefkriteriumDetailEditModal.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__